

/**
 * Key in the (browser's) local storage where a possible string is stored
 * that allows the client to bypass the maintenance mode.
 */
export const KEY_STORAGE_ITEM = "bypassMaintenanceKey"

/**
 * Key in the (browser's) local storage where a possible string is stored
 * that encodes the timestamp of the last access on the key.
 * If this timestamp is older than `KEY_TIMEOUT` minutes,
 * the key is removed from localStorage.
 */
export const TIMESTAMP_STORAGE_ITEM = "bypassMaintenanceTimestamp"
